import { Arrow } from 'assets/SVG';
import React, { useState } from 'react';
import { Form, Button, Row, Col, Container, ButtonGroup, Alert } from 'react-bootstrap';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        company: '',
        message: ''
    });


    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formStatus, setFormStatus] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormStatus('');

        // Web3Forms API URL
        const formUrl = 'https://api.web3forms.com/submit';

        // Web3Forms payload
        const formPayload = {
            ...formData,
            access_key: '2c09ebb7-5dae-490d-abee-8f4aaadfa84c',  // Your Web3Forms API Key
        };

        // Sending the form data using POST request
        fetch(formUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formPayload),
        })
            .then((response) => {
                if (response.ok) {
                    setFormStatus('success');
                    setFormData({
                        firstName: '',
                        lastName: '',
                        email: '',
                        phone: '',
                        company: '',
                        message: ''
                    });
                } else {
                    setFormStatus('error');
                }
            })
            .catch((error) => {
                console.error('Form submission error:', error);
                setFormStatus('error');
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <Container className="py-5">
            <Form onSubmit={handleSubmit}>
                {/* Hidden fields */}
                <input type="hidden" name="_subject" value="New submission from contact form" />
                <input type="hidden" name="_captcha" value="false" />

                {/* Form Status Alerts */}
                {formStatus === 'success' && (
                    <Alert variant="success">
                        Thank you for reaching out! We will get back to you soon.
                    </Alert>
                )}
                {formStatus === 'error' && (
                    <Alert variant="danger">
                        Something went wrong. Please try again later.
                    </Alert>
                )}

                <Row className="mb-3">
                    <Col className='mb-md-0 mb-3' md={6}>
                        <Form.Group controlId="formFirstName">
                            <Form.Control
                                type="text"
                                placeholder="First Name"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                className="border-0 rounded-3"
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formLastName">
                            <Form.Control
                                type="text"
                                placeholder="Last Name"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                className="border-0 rounded-3"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col className='mb-md-0 mb-3' md={6}>
                        <Form.Group controlId="formEmail">
                            <Form.Control
                                type="email"
                                placeholder="Email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="border-0 rounded-3"
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formPhone">
                            <Form.Control
                                type="tel"
                                placeholder="Phone Number"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className="border-0 rounded-3"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={12}>
                        <Form.Group controlId="formCompany">
                            <Form.Control
                                type="text"
                                placeholder="Company"
                                name="company"
                                value={formData.company}
                                onChange={handleChange}
                                className="border-0 rounded-3"
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group controlId="formMessage" className="mb-3">
                    <Form.Control
                        as="textarea"
                        rows={6}
                        placeholder="Message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className="border-0 rounded-3 py-3"
                        required
                    />
                </Form.Group>

                {/* Submit Button */}
                <ButtonGroup className="d-flex btn-group pt-4">
                    <Button
                        type="submit"
                        className="btn-custom"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Sending...' : 'Submit'}
                    </Button>
                    <span className="arrow">
                        <Arrow />
                    </span>
                </ButtonGroup>
            </Form>
        </Container>
    );
};

export default ContactForm;
